// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"em_a bhf_a bhf_x bhf_j bhf_u bhf_bc bhf_qj bhf_vt"};